import axios from 'axios';
import axiosRetry from 'axios-retry';

import Encrypt from '../../utilities/Encrypt';

/*
 global window
 */

const client = (() => {
  return axios.create({
    baseURL: Encrypt.auth.assureIDConnectEndpoint,
  });
})();

axiosRetry(client, { retries: 3 });

const request = function (options, store) {
  const onSuccess = function (response) {
    console.debug('Request Successful!', response);
    return response.data;
  };

  const onError = function (error) {
    return Promise.reject(error.response || error.message);
  };

  options.headers = {
    Authorization: `${Encrypt.auth.token_type} ${Encrypt.auth.access_token}`,
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;
